import React from 'react';

const visuallyHiddenStyle: React.CSSProperties = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0,
};

export default function LiveRegion({ message }: { message: string }): JSX.Element {
  return (
    <div role="status" aria-live="polite" aria-atomic="true" style={visuallyHiddenStyle}>
      {message}
    </div>
  );
}
